export const theme = {
  primary: "salmon",
  background: "#ffffff",
  smrt: "#EA1C2D",
  smrtSecondary: "#B28C3A",
  text: "#1E1E1E",
  green: "#3AA84C",
  red: "#F15663",
  font: "Euclid",
};

export const darkTheme = {
  primary: "salmon",
  background: "#1E1E1E",
  smrt: "#EA1C2D",
  smrtSecondary: "#B28C3A",
  text: "#ffffff",
  green: "#3AA84C",
  red: "#F15663",
  font: "Euclid",
};
